<div class="form-field-wrapper">
  <div class="app-form-field">
    @let control = getControl();
    <mat-form-field appearance="outline">
      <mat-label>{{ label() }}</mat-label>
      <input matInput [formControl]="control" maxlength="{{maxLength()}}">
    </mat-form-field>

    <app-tooltip [tooltip]="hint()"></app-tooltip>
  </div>
  <app-form-error [control]="control"></app-form-error>
</div>
